export default class OptionGroup {
    "optionGroupId": number;
    "name": string;
    "lineType": string;
    "ordinal": number;
} 